

/** ======[常用的名称配置项]================================================================================ */

const $str = window.$str;

/**
 * 获取时段电价对应的时段名称
 * @param {*} key 可选，不传时-返回colors对象，传时段名称时，返回对应时段的色值
 * 以sharp为例：'sharp', 'inSharp', 'outSharp', 'inSharpPrice', 'outSharpPrice' 在字典中获取到的颜色值，均为 '尖峰时段'
 * @returns 
 */
export function getElecPriceSegmentName(key, abbr = false) {
  const names = {
    sharp: {
      default: $str.getKey('收益管理/尖峰时段'),
      abbr: $str.getKey('收益管理/尖峰'),
    },
    peak: {
      default: $str.getKey('收益管理/高峰时段'),
      abbr: $str.getKey('收益管理/高峰'),
    },
    flat: {
      default: $str.getKey('收益管理/平时段'),
      abbr: $str.getKey('收益管理/平时段'),
    },
    valley: {
      default: $str.getKey('收益管理/低谷时段'),
      abbr: $str.getKey('收益管理/低谷'),
    },
    deepValley: {
      default: $str.getKey('收益管理/深谷时段'),
      abbr: $str.getKey('收益管理/深谷'),
    },
  } 
  const segmentList = Object.keys(names);

  const keyMap = new Map();
  const prefixArr = ['', 'in', 'out'];
  const suffixArr = ['', 'Price'];

  segmentList.forEach(it => {
    prefixArr.forEach(pre => {
      let baseKey = it;
      if (pre) {
        baseKey = it.charAt(0).toUpperCase() + it.slice(1);
      }
      suffixArr.forEach(fix => {
        const mapKey = pre + baseKey + fix;
        keyMap.set(mapKey, names[it]);
      })
    })
  })

  if (key) {
    if (keyMap.has(key)) {
      if (abbr) {
        return keyMap.get(key).abbr;
      } else {
        return keyMap.get(key).default;
      }
    } else {
      console.error(`电价没有 ${key} 对应时段的时段名称！`);
      return '';
    }
  } else {
    return names;
  }

}






/** ======[辅助功能方法]================================================================================ */




